import { render, staticRenderFns } from "./priceMarkFile.vue?vue&type=template&id=14d5da12&scoped=true&"
import script from "./priceMarkFile.vue?vue&type=script&lang=js&"
export * from "./priceMarkFile.vue?vue&type=script&lang=js&"
import style0 from "./priceMarkFile.vue?vue&type=style&index=0&id=14d5da12&prod&lang=scss&scoped=true&"
import style1 from "./priceMarkFile.vue?vue&type=style&index=1&id=14d5da12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d5da12",
  null
  
)

export default component.exports